export default __webpack_public_path__ + "static/media/delivering-wood.52aec1da.jpg";